import { render, staticRenderFns } from "./YourForestDialog.vue?vue&type=template&id=35745dec&scoped=true&"
import script from "./YourForestDialog.vue?vue&type=script&lang=js&"
export * from "./YourForestDialog.vue?vue&type=script&lang=js&"
import style0 from "./YourForestDialog.vue?vue&type=style&index=0&id=35745dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35745dec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg,VRow})
